import dayjs from "dayjs";
import { Constants } from "../../../../../../../utils/constants";
import { formaDetailtDataPayload, FormatDetailDataResponse } from "../types";
import { format } from "date-fns";
import { separateEvidenceType } from "../../../../../../questionnaire/pages/detail/contextProvider/provider/methods";
import { removeAllReference } from "../../../../../../../utils/methods/removedReference";

export const detailData = ({ oldData, responseReportFoliosById, t }: formaDetailtDataPayload): FormatDetailDataResponse => {
    const isSolve = responseReportFoliosById.reportFolioAnswers
    const answerSolve = isSolve?.[isSolve?.length - 1]
    const usersWithData = responseReportFoliosById?.reportFolioUserAssign?.filter(user => !!user?.id)
    const userAssigned = usersWithData.map(item => {
        const isReassigned = item.isReassign ? `R - ` : ''
        return ({
            id: item?.id?.toString(),
            label: `${isReassigned}${item?.firstName} ${item?.lastName}`,
            value: item?.id
        })
    }) || []
    const userTracking = responseReportFoliosById.usersTracking.map(item => `${item?.firstName} ${item?.lastName}`)
    let iCanRespond = !!responseReportFoliosById.canResponse
    const { approver, reject } = separateEvidenceType(removeAllReference(responseReportFoliosById?.configReportFolio?.configActionPlanReportFolioEvidenceTypes))
    const rejectEvidence = reject?.map((item) => ({
        evidence: item.evidenceTypeId,
        amount: item.paramsConfiguration?.amounts,
        min: item.paramsConfiguration.min,
        size: item.paramsConfiguration?.sizes,
        type: item?.paramsConfiguration?.types ?? Constants.acceptFile[item.evidenceTypeId.toString()],
        isRequired: !!item?.required,
        typeUser: item.type,
        key: item.evidenceType.key
    }))
    const approverEvidence = approver?.map((item) => ({
        evidence: item.evidenceTypeId,
        amount: item.paramsConfiguration?.amounts,
        min: item.paramsConfiguration.min,
        size: item.paramsConfiguration?.sizes,
        type: item?.paramsConfiguration?.types ?? Constants.acceptFile[item.evidenceTypeId.toString()],
        isRequired: !!item?.required,
        typeUser: item.type,
        key: item.evidenceType.key
    }))

    const categories = responseReportFoliosById.categories || [];
    const categoriesText = categories.length !== 0 ? categories.map(cat => cat.category).join(', ') : responseReportFoliosById.reportFolioCategory.description;
    const subcategoriesText = categories.length !== 0 ? categories.map(cat => cat.subcategory).join(', ') : responseReportFoliosById.reportFolioSubcategory.description;
    const subcategoryDetailsText = categories.length !== 0 ? categories
        .filter(cat => cat.subcategoryText)
        .map(cat => cat.subcategoryText)
        .join(', ') : responseReportFoliosById.reportFolioSubcategory.requestText ? responseReportFoliosById.subcategoryText : null;

    return {
        newData: {
            ...oldData,
            left: {
                categories: categories,
                approverEvidence,
                timeSla: responseReportFoliosById.sla ? {
                    dateCreateFolio: responseReportFoliosById.sla.dateCreateFolio,
                    dateFinishFolio: responseReportFoliosById.sla.dateFinishFolio,
                    timeConfig: responseReportFoliosById.sla.timeConfig
                } : null,
                timeOla: responseReportFoliosById.ola ? {
                    rangeDates: responseReportFoliosById.ola.rangeDates,
                    activeTimer: responseReportFoliosById.ola.activeTimer,
                    timeConfig: responseReportFoliosById.ola.timeConfig
                } : null,
                rejectEvidence,
                assignedQuestionnaire: responseReportFoliosById.assignedQuestionnaire,
                storeTimeZoneCode: responseReportFoliosById.store.storeTimeZone.code,
                questionarieName: responseReportFoliosById.assignedQuestionnaire?.questionnaireMainData.name,
                dateStart: responseReportFoliosById.dateStart,
                statusAttentionId: responseReportFoliosById.statusAttentionId,
                dateEnd: responseReportFoliosById.dateEnd,
                dateStarteDateFinish: `${dayjs(responseReportFoliosById.dateStart).tz(responseReportFoliosById.store.storeTimeZone.code).format(Constants.dayjsFormat)}  -  ${dayjs(responseReportFoliosById.dateEnd).tz(responseReportFoliosById.store.storeTimeZone.code).format(Constants.dayjsFormat)}`,
                title: responseReportFoliosById.name,
                type: responseReportFoliosById.type,
                reasonCancel: {
                    reason: responseReportFoliosById.reasonCancel,
                    date: dayjs(responseReportFoliosById.cancelTime).locale('es').format(Constants.dayjsHumanFormat),
                    user: responseReportFoliosById.cancelUser
                },
                reasonReassign: {
                    reason: responseReportFoliosById.reasonReassign,
                    date: dayjs(responseReportFoliosById.reassignTime).locale('es').format(Constants.dayjsHumanFormat),
                    user: responseReportFoliosById.reassignUser
                },
                canResponse: iCanRespond,
                answers: responseReportFoliosById?.detailCreation ? {
                    type: responseReportFoliosById?.detailCreation.typeQuestionId,
                    question: responseReportFoliosById?.detailCreation?.question ?? '',
                    answersList: responseReportFoliosById?.detailCreation?.answers?.map(item => ({
                        id: item?.id?.toString() ?? '',
                        label: item?.title ?? '',
                        value: !!item?.selected,
                        iconUrl: item?.iconUrl ?? ''
                    })) ?? [],
                    fullAnswer: responseReportFoliosById?.detailCreation?.fullAnswer?.map(item => ({
                        base: item.configAnswer[0].name,
                        text: item.listText,
                        values: item.configAnswer.slice(1).map(answer => answer.name)
                    }))
                } : null,
                evidencesConfig: responseReportFoliosById?.configReportFolio?.configActionPlanReportFolioEvidenceTypes
                    ?.map((item) => ({
                        evidence: item.evidenceTypeId,
                        amount: item.paramsConfiguration?.amounts,
                        size: item.paramsConfiguration?.sizes,
                        type: item?.paramsConfiguration?.types ?? Constants.acceptFile[item.evidenceTypeId.toString()],
                        isRequired: !!item?.required,
                        typeUser: item.type
                    })),

                bossAssigned: responseReportFoliosById?.userManageDepartment,
                userAssignedAmount: usersWithData?.length ?? 0,
                UserAssign:
                    usersWithData?.length > 0
                        ? usersWithData
                            ?.map((item) => {
                                const isReassigned = item.isReassign ? `R - ` : ''
                                return `${isReassigned}${item?.firstName} ${item?.lastName}`
                            })
                            .join(', ')
                        : t('reportFolio.detail.general.noUsersAssigned'),
                id: responseReportFoliosById?.id,
                canReassign: !!responseReportFoliosById?.canReassign,
                priority: responseReportFoliosById?.priority,
                folio: responseReportFoliosById?.folio,
                status: responseReportFoliosById?.status,
                description: responseReportFoliosById?.description,
                rating: {
                    required: responseReportFoliosById?.configReportFolio?.isRatingQuestionRequired,
                    rating: responseReportFoliosById?.rating,
                    ratingComment: responseReportFoliosById?.ratingComment,
                    ratingQuestion: responseReportFoliosById?.configReportFolio?.ratingQuestion,
                    showRating: responseReportFoliosById.configReportFolio.enableRatingQuestion
                },
                createBy: {
                    user: `${responseReportFoliosById?.createdByUser?.firstName} ${responseReportFoliosById?.createdByUser?.lastName}`,
                    date: responseReportFoliosById?.createTime && format(new Date(responseReportFoliosById?.createTime), Constants.dateFormatGeneral3),
                    id: responseReportFoliosById?.createdByUser?.id,
                },
                solveBy: !!answerSolve?.reviewerUser
                    ? {
                        user: `${answerSolve?.reviewerUser?.firstName} ${answerSolve?.reviewerUser?.lastName}`,
                        date: answerSolve?.createTime && format(new Date(answerSolve?.createTime), Constants.dateFormatGeneral2),
                    }
                    : null,
                unit: responseReportFoliosById?.store?.name ? `${responseReportFoliosById?.store?.keyCode} - ${responseReportFoliosById?.store?.name}` : '',
                area: responseReportFoliosById?.area?.name,
                department: responseReportFoliosById?.department?.name,
                departmentId: responseReportFoliosById.departmentId,
                evidences: responseReportFoliosById?.evidences,
                comments: responseReportFoliosById?.reportFolioComments
                    ?.slice()
                    .sort((a, b) => new Date(b.createTime).getTime() - new Date(a.createTime).getTime())
                    ?.map((itemComments) => ({
                        description: itemComments?.comment,
                        user: `${itemComments?.createdByUser?.firstName} ${itemComments?.createdByUser?.lastName}`,
                        date: itemComments?.createTime && format(new Date(itemComments?.createTime), Constants.dateFormatGeneral2),
                    }))
            },
            right: {
                canDoActions: responseReportFoliosById.canDoActions,
                reportUrl: responseReportFoliosById?.reportUrl,
                existAnyQuote: responseReportFoliosById?.existAnyQuote,
                existSolutionCaseMgDpto: responseReportFoliosById.existSolutionCaseMgDpto,
                descriptionApprove: responseReportFoliosById.configReportFolio?.configReportFolioApprover,
                descriptionReject: responseReportFoliosById.configReportFolio?.configReportFolioReject,
                answers: isSolve
                    ?.map((itemAnswers) => ({
                        status: itemAnswers?.status,
                        description: itemAnswers?.description,
                        reasonOfRejection: itemAnswers?.reasonOfRejection,
                        createTime: new Date(itemAnswers?.createTime)?.getTime(),
                        createBy: {
                            user: `${itemAnswers.createdByUser?.firstName} ${itemAnswers.createdByUser?.lastName}`,
                            date: itemAnswers?.createTime && format(new Date(itemAnswers?.createTime), Constants.dateFormatGeneral3),
                        },
                        commentApproval: itemAnswers.commentApproval,
                        evidences: itemAnswers.evidences,
                        evidencesRejection: itemAnswers.evidencesRejection,
                        evidencesApproval: itemAnswers.evidencesApproval,
                    }))
                    ?.sort((a, b) => b.createTime - a.createTime),
            },
        },
        userAssigned,
        userTracking,
    }
}